import React, { useState } from "react";
import { Link } from "@mui/material";
import SidebarLeft from "../../_asset/img/sidebar-left.svg";
import NotificationIcon from "../../_asset/img/notification.svg";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useUser } from "../../../context/UserContext";
import Notifications from "./notifications"; // Make sure to adjust the import path based on your file structure

const OfficerHeader = ({ isOpen, setIsOpen }) => {
    const { userInfo } = useUser();
    const location = useLocation();
    const pathName = location?.pathname?.split('/')?.[4];

    // State to manage notification dropdown visibility and notifications
    const [showNotifications, setShowNotifications] = useState(false);
    const [notifications, setNotifications] = useState([
        // Example dummy notifications; replace with fetched data as needed
        { message: "Offer rejected by Elon", createdAt: new Date(), readBy: [], link: "/projects/1" },
        { message: "New job assigned for fulfillment", createdAt: new Date(), readBy: [], link: "/meetings" },
    ]);
    const [unreadCount, setUnreadCount] = useState(notifications.length);

    // Toggle notification dropdown visibility
    const toggleNotifications = () => setShowNotifications(!showNotifications);

    return (
        <div className="header_wrapper">
            <div className="leftside">
                <div className={`menubar ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                    <img src={SidebarLeft} alt="Sidebar Toggle" />
                </div>
                <span className="page_name" style={{ textTransform: 'capitalize' }}>
                    {pathName.replace('-', ' ')}
                </span>
            </div>
            <div className="rightside">

                {/* <div className="notification" onClick={toggleNotifications}>
                    <img src={NotificationIcon} alt="Notifications" />
                    {unreadCount > 0 && <span className="notification-icon">{unreadCount}</span>}
                    {showNotifications && (
                        <div className="notification-dropdown">
                            <Notifications
                                notifs={notifications}
                                setNotifs={setNotifications}
                                n={unreadCount}
                                setN={setUnreadCount}
                            />
                        </div>
                    )}
                </div> */}

                <span className="line"></span>

                <div className="profile">
                    <Link to="/home" className="dashboard-sidebar-avatar-link">
                        <div className="w-10 h-10 rounded-full border-2 border-gray-300 flex items-center justify-center bg-gray-100 overflow-hidden">
                            {userInfo.profilePictureUrl ? (
                                <img 
                                    src={userInfo.profilePictureUrl} 
                                    alt="Profile" 
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <span className="text-gray-600 text-sm font-medium">
                                    {userInfo.firstName?.charAt(0)?.toUpperCase()}
                                </span>
                            )}
                        </div>
                    </Link>
                    <div className="user_details">
                        <p className="name">{userInfo.firstName} {userInfo.lastName}</p>
                        <span className="roll">Officer</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfficerHeader;
